import * as actionTypes from '../../actionTypes';

// js utility library
import _ from 'lodash';

export const initialState = {};


export default function staticDataReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_STATIC_DATA:
      return action.staticData;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/staticData/index.js